import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["body", "header", "collapseIcon"];

  connect() {
    this.toggleBody = this.toggleBody.bind(this);
    this.headerTarget.addEventListener("click", this.toggleBody);
    if (this.headerTarget.dataset.openValue === "true") {
      this.toggleBody();
    }
  }

  disconnect() {
    this.element.removeEventListener("click", this.toggleBody);
  }

  toggleBody() {
    this.bodyTarget.classList.toggle("hidden");
    this.collapseIconTarget.classList.toggle("rotate-180");
  }
}
